import { NoDataMessage } from './NoDataMessage';

export default NoDataMessage;
